import { BrandingStyle } from "@bcm-dev/bcms-vite";
import "./styles.css";
export default function PickerFooter(props) {
    let { hoverDate } = props;
    return (
       <div className="picker-footer">
            <div className="transfer-date-row flex-container flex-horizontal align-center">              
                    <BrandingStyle 
                        style={{ "backgroundColor" : "primary_button_bg_abi22"}} 
                        className="day-number" 
                        element={
                            <span>{hoverDate.dayInt}</span>
                        } />
                    <span className="day-label">Transfer Date</span>              
            </div>
            <div className="estimated-date-row">    
                <BrandingStyle 
                    style={{ "outlineColor" : "primary_button_bg_abi22" }}
                    className="day-number"
                    element={
                        <span>{hoverDate.dayInt}</span>
                    } />
                <span className="day-label">Estimated Delivery Date</span>            
        </div>
     </div> 
    )
}
